var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter_2_",
    "data-name": "twitter (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.15,
    height: 31.15,
    viewBox: "0 0 31.15 31.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M15.575,0A15.575,15.575,0,1,1,0,15.575,15.575,15.575,0,0,1,15.575,0Z",
    fill: "#1f94a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M80.171,83.524a6.9,6.9,0,0,1-1.94.517,3.3,3.3,0,0,0,1.486-1.815,6.847,6.847,0,0,1-2.146.8A3.421,3.421,0,0,0,75.1,81.988a3.328,3.328,0,0,0-3.377,3.277,3.181,3.181,0,0,0,.087.748,9.688,9.688,0,0,1-6.961-3.425,3.184,3.184,0,0,0-.457,1.648,3.25,3.25,0,0,0,1.5,2.728,3.434,3.434,0,0,1-1.531-.411v.042a3.307,3.307,0,0,0,2.71,3.215,3.493,3.493,0,0,1-.89.115,3.405,3.405,0,0,1-.635-.059,3.368,3.368,0,0,0,3.156,2.276,6.9,6.9,0,0,1-4.2,1.4,7.1,7.1,0,0,1-.806-.046,9.774,9.774,0,0,0,5.178,1.473,9.4,9.4,0,0,0,9.61-9.328l-.01-.424A6.741,6.741,0,0,0,80.171,83.524Z",
    transform: "translate(-56.058 -72.527)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTwitter);
export default __webpack_public_path__ + "static/media/blue-twitter.2cf1c5a60bae26018fe15b7e01f03c2e.svg";
export { ForwardRef as ReactComponent };